module.exports = __webpack_public_path__ + "img/zyjp.054f5bde.jpg";